import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { ConsultationStorageService } from '@services/consultation-storage.service';
import { NavigationService } from '@services/navigation.service';

@Injectable({
  providedIn: 'root',
})
export class ConsultationPharmacyStateGuard implements CanActivate {
  private router = inject(Router);
  private consultationStorageService = inject(ConsultationStorageService);
  private navigation = inject(NavigationService);

  private readonly PUERTO_RICO_STATE = 'PR';

  /**
   * Determines whether the current route can be activated.
   *
   * @param {ActivatedRouteSnapshot} route the route to be activated
   * @param {RouterStateSnapshot} state the current router state
   */
  public async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    if (this.consultationStorageService.pharmacy?.state !== this.PUERTO_RICO_STATE) {
      return true;
    }

    const nextPageUrl = await this.navigation.getConsultationRequestNextPageUrl(
      this.consultationStorageService.treatmentType,
      state.url,
    );

    return this.router.createUrlTree([nextPageUrl]);
  }
}
